var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomleft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 153,
    viewBox: "0 0 167 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.1698 126.62C72.8079 126.62 78.9998 120.428 78.9998 112.79C78.9998 105.152 72.8079 98.96 65.1698 98.96C57.5317 98.96 51.3398 105.152 51.3398 112.79C51.3398 120.428 57.5317 126.62 65.1698 126.62Z",
    fill: "#FFC200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.06 112.76L138.89 105.92L136.88 103.91L128.03 112.76L136.88 121.61L138.89 119.59L132.06 112.76Z",
    fill: "#FF9D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.99 112.76L150.82 105.92L148.81 103.91L139.96 112.76L148.81 121.61L150.82 119.59L143.99 112.76Z",
    fill: "#FF9D00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.06 112.76L162.9 105.92L160.88 103.91L152.04 112.76L160.88 121.61L162.9 119.59L156.06 112.76Z",
    fill: "#FF9D00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.06 112.76L114.89 105.92L112.88 103.91L104.03 112.76L112.88 121.61L114.89 119.59L108.06 112.76Z",
    fill: "#FF9D00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.99 112.76L126.82 105.92L124.81 103.91L115.96 112.76L124.81 121.61L126.82 119.59L119.99 112.76Z",
    fill: "#FF9D00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.93 152.86C36.87 152.86 36 152 36 150.93C36 149.87 36.86 149 37.93 149C39 149 39.86 149.86 39.86 150.93C39.86 152 39 152.86 37.93 152.86Z",
    fill: "#0B315E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0696 152.86C55.0096 152.86 54.1396 152 54.1396 150.93C54.1396 149.87 54.9996 149 56.0696 149C57.1396 149 57.9996 149.86 57.9996 150.93C57.9996 152 57.1296 152.86 56.0696 152.86Z",
    fill: "#0B315E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1995 152.86C73.1395 152.86 72.2695 152 72.2695 150.93C72.2695 149.87 73.1295 149 74.1995 149C75.2595 149 76.1295 149.86 76.1295 150.93C76.1295 152 75.2695 152.86 74.1995 152.86Z",
    fill: "#0B315E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3402 152.86C91.2802 152.86 90.4102 152 90.4102 150.93C90.4102 149.87 91.2702 149 92.3402 149C93.4002 149 94.2702 149.86 94.2702 150.93C94.2702 152 93.4002 152.86 92.3402 152.86Z",
    fill: "#0B315E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.48 152.86C109.42 152.86 108.55 152 108.55 150.93C108.55 149.87 109.41 149 110.48 149C111.54 149 112.41 149.86 112.41 150.93C112.4 152 111.54 152.86 110.48 152.86Z",
    fill: "#0B315E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.61 152.86C127.55 152.86 126.68 152 126.68 150.93C126.68 149.87 127.54 149 128.61 149C129.67 149 130.54 149.86 130.54 150.93C130.54 152 129.67 152.86 128.61 152.86Z",
    fill: "#0B315E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M146.75 152.86C145.69 152.86 144.82 152 144.82 150.93C144.82 149.87 145.68 149 146.75 149C147.81 149 148.68 149.86 148.68 150.93C148.67 152 147.81 152.86 146.75 152.86Z",
    fill: "#0B315E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M164.88 152.86C163.82 152.86 162.95 152 162.95 150.93C162.95 149.87 163.81 149 164.88 149C165.94 149 166.81 149.86 166.81 150.93C166.81 152 165.95 152.86 164.88 152.86Z",
    fill: "#0B315E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.99 1H0V75.55H96.99C107.26 75.53 116.55 71.37 123.29 64.63C130.04 57.89 134.21 48.57 134.21 38.28C134.21 17.71 117.55 1.03 96.99 1Z",
    fill: "#FF9D00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M134.21 38.28C134.21 48.57 130.04 57.89 123.29 64.63C116.55 71.37 107.26 75.53 96.9897 75.55H96.9297C76.3697 75.52 59.7197 58.84 59.7197 38.28C59.7197 17.71 76.3697 1.03 96.9297 1H96.9897C117.55 1.03 134.21 17.71 134.21 38.28Z",
    fill: "#FF9D00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9897 76.55C75.8597 76.52 58.7197 59.35 58.7197 38.28C58.7197 17.2 75.8597 0.03 96.9297 0C118.07 0.03 135.21 17.2 135.21 38.28C135.21 48.51 131.23 58.12 124 65.34C116.79 72.55 107.2 76.53 96.9897 76.55ZM96.9897 2C76.9697 2.03 60.7197 18.3 60.7197 38.28C60.7197 58.25 76.9597 74.52 96.9297 74.55C106.66 74.53 115.75 70.76 122.58 63.92C129.43 57.08 133.21 47.97 133.21 38.28C133.21 18.31 116.96 2.03 96.9897 2Z",
    fill: "#0B315E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomleft);
export default __webpack_public_path__ + "static/media/bottomleft.4c67a49abecc92a16927bb7685623452.svg";
export { ForwardRef as ReactComponent };